import { Model } from '@nozbe/watermelondb'
import { field, date } from '@nozbe/watermelondb/decorators'

export const RealmColumns = [
    { name: 'user_id', type: 'number', isOptional: true },
    { name: 'parent_id', type: 'number' },
    { name: 'name', type: 'string' },
    { name: 'tier', type: 'string' },
    { name: 'config', type: 'string', isOptional: true },
    { name: 'active', type: 'number' },
    { name: 'client_key', type: 'string', isOptional: true },
    { name: 'created_at', type: 'number' },
    { name: 'updated_at', type: 'number' },
]

export class Realm extends Model {
    static table = 'realm'
    
    @field('user_id') userId
    @field('parent_id') parentId
    @field('name') name
    @field('tier') tier
    @field('config') config
    @field('active') active
    @field('client_key') clientKey
    @date('created_at') createdAt
    @date('updated_at') updatedAt
}